import { render, staticRenderFns } from "./FAlert.vue?vue&type=template&id=b4f36766&"
import script from "./FAlert.vue?vue&type=script&lang=ts&"
export * from "./FAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports